import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'lib-tooltip-rewards',
  imports: [],
  templateUrl: './tooltip-rewards.html',
  styleUrl: './tooltip-rewards.scss',
})
export class TooltipRewards {
  @Output() close = new EventEmitter<void>();
  
  items = [
    {
      icon: 'shell/profile/noto_hotel.svg',
      title: 'Gana 15 % de comisión',
      desc: 'Por la venta de un alojamiento'
    },
    {
      icon: 'shell/profile/emoji-adult.svg',
      title: 'Gana S/ 10.00 de comisión',
      desc: 'Por la venta de un adulto'
    },
    {
      icon: 'shell/profile/emoji-kid.svg',
      title: 'Gana S/ 7.50 de comisión',
      desc: 'Por la venta de un niño'
    },
    {
      icon: 'shell/profile/noto_party-popper.svg',
      title: 'Gana S/ 5 de comisión',
      desc: 'Por promover un evento'
    }
  ];
}
